// extracted by mini-css-extract-plugin
export default {"title":"benefits_title__mvSke","card_floating_img_cards":"benefits_card_floating_img_cards__+J37V"};